import { Entity } from "@jobilla/entity";
import { Currency } from "./currency";

export class Money extends Entity {
  amount = 0;
  currency!: Currency;

  constructor(amount?: number, currency: Currency = Currency.EUR) {
    super();

    this.amount = amount ?? 0;
    this.currency = currency;
  }

  get amountWithoutCents() {
    return this.amount / 100;
  }

  get formatted() {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: this.currency,
    }).format(this.amountWithoutCents);
  }

  add(money?: Money) {
    if (!money) {
      return this;
    }

    if (this.currency !== money.currency) {
      throw new Error("Currencies do not match");
    }

    return new Money(this.amount + money.amount, this.currency);
  }

  divide(divisor: number) {
    return new Money(this.amount / divisor, this.currency);
  }
}
